export default __webpack_public_path__ + "static/media/Familiarization-Programme.5d3a71f1.pdf";